import React from 'react';
import { DashboardContentType } from 'shared/prisma/types';
import TextContent from './TextContent';
import ResultContent from './ResultContent';

const DashboardContent = ({ content, globalFilter, dashboardFilter, onSizeChange, onUpdateContent, canOverrideFilter, onUpdateFilter, onCopyToDashboard, customerId, dataSourceIds, websites, viewDate, skipCurrencyQuery }) => {
  if (content.type === DashboardContentType.Text) {
    return (
      <TextContent
        content={content}
        onSizeChange={onSizeChange}
        onUpdateContent={onUpdateContent}
      />
    );
  }

  return (
    <ResultContent
      content={content}
      dashboardFilter={dashboardFilter}
      globalFilter={globalFilter}
      onSizeChange={onSizeChange}
      onUpdateContent={onUpdateContent}
      canOverrideFilter={canOverrideFilter}
      onUpdateFilter={onUpdateFilter}
      onCopyToDashboard={onCopyToDashboard}
      customerId={customerId}
      dataSourceIds={dataSourceIds}
      websites={websites}
      viewDate={viewDate}
      skipCurrencyQuery={skipCurrencyQuery}
    />
  );
};

export default DashboardContent;
